import { i18n } from '@/lang/index.js'

// 获取 i18n 翻译函数
const t = (key) => {
  try {
    return i18n.global.t(key)
  } catch (e) {
    return key
  }
}

export default {
    get ROOMS_EMPTY() { return t('whatsapp.rooms.empty') },
    get ROOM_EMPTY() { return t('whatsapp.room.empty') },
    get NEW_MESSAGES() { return t('whatsapp.new.messages') },
    get MESSAGE_DELETED() { return t('whatsapp.message.deleted') },
    get MESSAGES_EMPTY() { return t('whatsapp.messages.empty') },
    get CONVERSATION_STARTED() { return t('whatsapp.conversation.started') },
    get TYPE_MESSAGE() { return t('whatsapp.type.message') },
    get SEARCH() { return t('whatsapp.search') },
    get IS_ONLINE() { return t('whatsapp.is.online') },
    get LAST_SEEN() { return t('whatsapp.last.seen') },
    get IS_TYPING() { return t('whatsapp.is.typing') },
    get CANCEL_SELECT_MESSAGE() { return t('whatsapp.cancel.select.message') },
    get ROOMS_BAN_WARNING() { return t('whatsapp.rooms.ban.warning') },
    get ROOMS_BAN_GUIDE() { return t('whatsapp.rooms.ban.guide') }
}
